import React from 'react'

function PortfolioExample({title, description, services, image, link, type}) {
  return (
    <div className='card group overflow-hidden h-full flex flex-col'>
      {/* Image Container - Only show for game projects */}
      {image && (
        <div className='relative overflow-hidden'>
          <img 
            src={image} 
            alt={title} 
            className='w-full h-48 object-cover group-hover:scale-105 transition-transform duration-300' 
          />
          <div className='absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300'></div>
          
          {/* Project Type Badge */}
          <div className='absolute top-3 right-3'>
            {type === 'Game' ? (
              <div className='bg-purple-500 text-white px-3 py-1 rounded-full text-xs font-medium flex items-center gap-1'>
                <svg className='w-3 h-3' fill='currentColor' viewBox='0 0 24 24'>
                  <path d='M21.58 16.09l-1.09-7.66C20.21 6.46 18.52 5 16.53 5H7.47C5.48 5 3.79 6.46 3.51 8.43l-1.09 7.66C2.2 17.63 3.39 19 4.94 19h0c.68 0 1.32-.27 1.8-.75L9 16h6l2.25 2.25c.48.48 1.12.75 1.8.75h0c1.56 0 2.75-1.37 2.53-2.91z'/>
                </svg>
                Game
              </div>
            ) : (
              <div className='bg-blue-500 text-white px-3 py-1 rounded-full text-xs font-medium flex items-center gap-1'>
                <svg className='w-3 h-3' fill='currentColor' viewBox='0 0 24 24'>
                  <path d='M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2z'/>
                </svg>
                Web
              </div>
            )}
          </div>
        </div>
      )}

      {/* Content */}
      <div className='p-6 flex-grow flex flex-col'>
        <h3 className='text-xl font-semibold text-slate-800 mb-3 group-hover:text-blue-600 transition-colors duration-200'>
          {title}
        </h3>
        <p className='text-slate-600 mb-4 leading-relaxed flex-grow'>
          {description}
        </p>
        
        {/* Services Section */}
        {services && (
          <div className='mb-6'>
            <h4 className='text-sm font-semibold text-slate-700 mb-2 flex items-center gap-2'>
              <svg className='w-4 h-4 text-blue-500' fill='currentColor' viewBox='0 0 24 24'>
                <path d='M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z'/>
              </svg>
              Services Provided
            </h4>
            <div className='flex flex-wrap gap-2'>
              {services.split(', ').map((service, index) => (
                <span 
                  key={index} 
                  className='bg-slate-100 text-slate-700 px-2 py-1 rounded-md text-xs font-medium'
                >
                  {service}
                </span>
              ))}
            </div>
          </div>
        )}
        
        {/* Action Button */}
        <a 
          href={link} 
          target='_blank' 
          rel='noopener noreferrer' 
          className='btn-secondary w-full justify-center inline-flex items-center gap-2 group/btn mt-auto'
        >
          View Project
          <svg className='w-4 h-4 group-hover/btn:translate-x-1 transition-transform duration-200' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
            <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14' />
          </svg>
        </a>
      </div>
    </div>
  )
}

export default PortfolioExample